<!-- Roles OUTSIDE, permissions inside: a role decides whether the section
     exists for this kind of account at all, a permission whether this account
     may read it. Both are structural, so an item survives only if it clears
     both — and `roles` is null on almost every item, which the directive reads
     as "no constraint", so every existing entry keeps working untouched. -->
<ng-container *data-roles="roles">
<ng-container *data-permissions="auth">
  @if (root && item.visible !== false) {
    <div class="layout-menuitem-root-text">{{ item.label }}</div>
  }
  @if ((!item.routerLink || item.items) && item.visible !== false) {
    <a [attr.href]="item.url"
      (click)="itemClick($event)"
      [ngClass]="item.styleClass"
      [class.p-disabled]="item.disabled"
      [attr.target]="item.target"
      [attr.tabindex]="item.disabled ? '-1' : '0'"
      pRipple
      >
      <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
      <span class="layout-menuitem-text">{{ item.label }}</span>
      @if (item.items) {
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
      }
    </a>
  }
  @if (item.routerLink && !item.items && item.visible !== false) {
    <a
      (click)="itemClick($event)"
      [ngClass]="item.styleClass"
      [class.p-disabled]="item.disabled"
      [routerLink]="item.disabled ? null : item.routerLink"
      routerLinkActive="active-route"
      [routerLinkActiveOptions]="item.routerLinkActiveOptions || { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
      [fragment]="item.fragment"
      [queryParamsHandling]="item.queryParamsHandling"
      [preserveFragment]="item.preserveFragment"
      [skipLocationChange]="item.skipLocationChange"
      [replaceUrl]="item.replaceUrl"
      [state]="item.state"
      [queryParams]="item.queryParams"
      [attr.target]="item.target"
      [attr.tabindex]="item.disabled ? '-1' : '0'"
      pRipple>
      <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
      <span class="layout-menuitem-text">{{ item.label }}</span>
      @if (item.items) {
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
      }
    </a>
  }
  @if (item.items && item.visible !== false) {
    <ul [@children]="submenuAnimation">
      @for (child of item.items; track child; let i = $index) {
        <li app-menu-item [item]="child" [index]="i" [parentKey]="key" [class]="child['badgeClass']"></li>
      }
    </ul>
  }
</ng-container>
</ng-container>
